import React, { useMemo } from 'react';
import { Col, Row, Space } from 'antd';
import {
  DateText,
  GreetingText,
  SubGreetingText,
} from './DashboardStyle';
import { ThemeButton, ThemeMainWrapper } from '../Styles/Theme';
import MobHeader from '../../Components/Header/MobHeader';
import { useNavigate } from 'react-router-dom';
import { getUserData, hasModuleAccess, hasSubModuleAccess, MODULES } from '../../utils/permissions';
import UsageMonitoring from './UsageMonitoring';

const Dashboard = () => {
  const navigate = useNavigate();
  const userData = getUserData();

  const formattedDate = useMemo(() => {
    const today = new Date();
    const options = { weekday: 'long', month: 'long', day: '2-digit', year: 'numeric' };
    return today.toLocaleDateString('en-US', options);
  }, []);

  const greetingName = useMemo(() => {
    return userData?.name || 'User';
  }, [userData]);

  const canAccessInsightEngine = hasModuleAccess(MODULES.INSIGHTS_ENGINE);
  const canAccessSurveyBuilder = hasModuleAccess(MODULES.SURVEY_BUILDER);
  const canAccessAiJdv = hasModuleAccess(MODULES.AI_JDV);
  const canAccessUsageMonitoring = hasSubModuleAccess(MODULES.DASHBOARD, 'usage-monitoring');

  const handleInsightEngineClick = () => {
    if (canAccessInsightEngine) navigate('/insight-engine/');
  };
  const handleSurveyBuilderClick = () => {
    if (canAccessSurveyBuilder) navigate('/surveys/');
  };
  const handleAiJdvClick = () => {
    if (canAccessAiJdv) navigate('/polling-agents/');
  };

  return (
    <>
      <MobHeader />
      <ThemeMainWrapper>
        <Row gutter={[16, 16]} className="mb-6">
          <Col xs={24} className="text-center lg:text-center xl:text-end">
            <DateText>{formattedDate}</DateText>
          </Col>
          <Col xs={24} sm={24} md={24} lg={24} xl={8}>
            <GreetingText>Hello {greetingName},</GreetingText>
            <SubGreetingText>How can I help you today?</SubGreetingText>
          </Col>
          <Col xs={24} sm={24} md={24} lg={24} xl={16} className="text-center lg:text-center xl:text-end">
            <Space gap={16} wrap={true}>
              {canAccessInsightEngine && (
                <ThemeButton className="noBackground" size="large" icon={<img src="/images/insights-icons.svg" alt="Analyze" />} onClick={handleInsightEngineClick}>
                  Analyze
                </ThemeButton>
              )}
              {canAccessSurveyBuilder && (
                <ThemeButton className="noBackground" size="large" icon={<img src="/images/Survey-builder-icon.svg" alt="Survey Builder" />} onClick={handleSurveyBuilderClick}>
                  Launch Survey Builder
                </ThemeButton>
              )}
              {canAccessAiJdv && (
                <ThemeButton className="noBackground" size="large" icon={<img src="/images/aj-jdv-icon.svg" alt="Design" />} onClick={handleAiJdvClick}>
                  Design
                </ThemeButton>
              )}
            </Space>
          </Col>
        </Row>

        {/* Usage Monitoring */}
        {canAccessUsageMonitoring && <UsageMonitoring />}
      </ThemeMainWrapper>
    </>
  );
};

export default Dashboard;
